import React, { FC } from 'react';

export const AlertIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.707 3 21 8.293v7.414L15.707 21H8.293L3 15.707V8.293L8.293 3h7.414Zm-.414 1H8.706L4 8.706v6.587L8.707 20h6.585L20 15.292V8.707L15.293 4ZM12 15a1 1 0 0 1 .117 1.993L12 17a1 1 0 0 1-.117-1.993L12 15Zm0-8a1 1 0 0 1 1 1v4a1 1 0 0 1-.883.993L12 13a1 1 0 0 1-1-1V8a1 1 0 0 1 .883-.993L12 7Z"
      fill="currentColor"
    />
  </svg>
);
